function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "17407B6D-4773-4486-AC0E-FE9ECDDB8D18@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-899.000000, -1452.000000)",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined-Shape",
  transform: "translate(896.000000, 1448.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,4 C16.9705627,4 21,7.581722 21,12 C21,16.418278 16.9705627,20 12,20 C11.1058447,20 10.2421446,19.8840938 9.42687783,19.6682619 C8.84758191,20.164463 8.20488625,20.6083965 7.5,21 C6.08147114,21.7880716 4.58147114,22.1214049 3,22 C3.93394246,21.0010353 4.60060913,20.0020707 5,19.003106 C5.32661298,18.1861749 5.38612912,17.590235 5.17854843,17.2152863 L5.13888758,17.1776095 C3.80486261,15.782216 3,13.9746572 3,12 C3,7.581722 7.02943725,4 12,4 Z M14,13 L8,13 C7.44771525,13 7,13.4477153 7,14 C7,14.5522847 7.44771525,15 8,15 L8,15 L14,15 C14.5522847,15 15,14.5522847 15,14 C15,13.4477153 14.5522847,13 14,13 L14,13 Z M16,9 L8,9 C7.44771525,9 7,9.44771525 7,10 C7,10.5522847 7.44771525,11 8,11 L8,11 L16,11 C16.5522847,11 17,10.5522847 17,10 C17,9.44771525 16.5522847,9 16,9 L16,9 Z"
}))));

var SvgSpeechBubble = function SvgSpeechBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeechBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speech-bubble.0e295a80.svg";
export { ForwardRef as ReactComponent };